import * as React from 'react';
import util from '../../Util/util';
import Grid from '@material-ui/core/Grid';

interface EnquiryResultTableViewCellProps {
    idx: number,
    chassisNo: string,
    license: string,
    endDate: string,
    clickCell: (idx: number) => void
}

class EnquiryResultTableViewCell extends React.Component <EnquiryResultTableViewCellProps, {}> {
    public render() {
        return (
            <div className="cmTableViewCell cmText cmClickable" onClick={(e) => this.props.clickCell(this.props.idx)}>
                <Grid className="cmTableViewCol" item xs={5}>
                    <div>{this.props.chassisNo}</div>
                </Grid>
                <Grid className="cmTableViewCol" item xs={4}>
                    <div>{util.getLicense(this.props.license)}</div>
                </Grid>
                <Grid className="cmTableViewCol" item xs={3}>
                    <div>{util.getFormattedDate(this.props.endDate)}</div>
                </Grid>
            </div>
        );
    }
}

export default EnquiryResultTableViewCell;



// WEBPACK FOOTER //
// ./src/Components/Enquiry/EnquiryResultTableViewCell.tsx